import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  templateUrl: './debug.component.html',
  styleUrls: ['./debug.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DebugPageComponent {}
